import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getOurCulturePhotos} from "../actions";
import { getCulturePhotosApi } from "../../API/API";

function* getPhotosSaga(action) {
  try {
    const response = yield call(() => getCulturePhotosApi(action)); // API Backend
    yield put({ type: types.GET_CULTURE_PHOTOS_SUCCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_CULTURE_PHOTOS_FAILURE, error });
  }
}

export function* watchGetCulturePhotosSaga() {
  yield takeEvery(types.GET_CULTURE_PHOTOS_REQUESTED, getPhotosSaga);
}
